import { types, API_URL } from './types';
import { axiosApi } from './index';

export const getClients = (search = '') => {
  let url = `${API_URL}/api/v1/client`;
  if (search !== '') {
    url += `?search=${search}`;
  }
  return (dispatch) => {
    let outputData = {};
    axiosApi.get(url).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setGetClients(outputData));
      } else {
        outputData['status'] = data.status;
        outputData['message'] = data.message;
        outputData['data'] = data.data;
        dispatch(setGetClients(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setGetClients({ status: 'danger', error: true, message }));
      });
  };
};

export const setGetClients = (data) => ({
  type: types.cmGetClients,
  payload: data,
});

export const deleteClientById = (clientId) => {
  const url = `${API_URL}/api/v1/client/${clientId}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.delete(url).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setDeleteClientById(outputData));
      } else {
        outputData['status'] = data.status;
        outputData['message'] = data.message;
        outputData['data'] = data;
        outputData['clientId'] = clientId;
        dispatch(setDeleteClientById(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setDeleteClientById({ status: 'danger', error: true, message }));
      });
  };
};

export const setDeleteClientById = (data) => ({
  type: types.cmDeleteClientById,
  payload: data,
});

export const getClientById = (clientId) => {
  const url = `${API_URL}/api/v1/client/detail/${clientId}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .get(url, {
        validateStatus: false,
      })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setGetClientById(outputData));
        } else {
          outputData['status'] = data.status;
          outputData['message'] = data.message;
          outputData['data'] = data.data;
          dispatch(setGetClientById(outputData));
        }
      })
        .catch((error) => {
          const status = error.response?.status;
          const message =
            status === 403 ? 'No tienes permisos para esta acción.' :
            status === 404 ? 'Recurso no encontrado.' :
            status === 500 ? 'Error del servidor. Intenta nuevamente.' :
            'Error de red. Verifica tu conexión.';
          dispatch(setGetClientById({ status: 'danger', error: true, message }));
        });
  };
};

export const setGetClientById = (data) => ({
  type: types.cmGetClientById,
  payload: data,
});

export const createClient = (clientInfo) => {
  const url = `${API_URL}/api/v1/client/create`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .post(url, clientInfo, {
        validateStatus: false,
      })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setCreateClient(outputData));
        } else {
          outputData['status'] = data.status;
          outputData['message'] = data.message;
          outputData['data'] = data;
          dispatch(setCreateClient(outputData));
        }
      })
        .catch((error) => {
          const status = error.response?.status;
          const message =
            status === 403 ? 'No tienes permisos para esta acción.' :
            status === 404 ? 'Recurso no encontrado.' :
            status === 500 ? 'Error del servidor. Intenta nuevamente.' :
            'Error de red. Verifica tu conexión.';
          dispatch(setCreateClient({ status: 'danger', error: true, message }));
        });
  };
};

export const setCreateClient = (data) => ({
  type: types.cmCreateClient,
  payload: data,
});

export const updateClient = (clientId, clientInfo) => {
  const url = `${API_URL}/api/v1/client/edit/${clientId}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .put(url, clientInfo, {
        validateStatus: false,
      })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setUpdateClient(outputData));
        } else {
          outputData['status'] = data.status;
          outputData['message'] = data.message;
          outputData['data'] = data;
          dispatch(setUpdateClient(outputData));
        }
      })
        .catch((error) => {
          const status = error.response?.status;
          const message =
            status === 403 ? 'No tienes permisos para esta acción.' :
            status === 404 ? 'Recurso no encontrado.' :
            status === 500 ? 'Error del servidor. Intenta nuevamente.' :
            'Error de red. Verifica tu conexión.';
          dispatch(setUpdateClient({ status: 'danger', error: true, message }));
        });
  };
};

export const setUpdateClient = (data) => ({
  type: types.cmUpdateClient,
  payload: data,
});

export const downloadClients = (
  categories = [],
  includeClientsWithoutInterests = false,
) => {
  let url = `${API_URL}/api/v1/client/export`;
  const params = [];

  // Add categories filter if provided
  if (categories && categories.length > 0) {
    const categoriesParam = categories.join(',');
    params.push(`categories=${encodeURIComponent(categoriesParam)}`);
  }

  // Add include clients without interests parameter
  if (includeClientsWithoutInterests) {
    params.push('include_no_interests=true');
  }

  // Append parameters to URL
  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }

  return (dispatch) => {
    axiosApi
      .get(url, {
        responseType: 'blob',
      })
      .then(({ data }) => {
        dispatch(setDownloadClients(data));
      })
      .catch((error) => {
        console.error('Error downloading clients:', error);
        dispatch(setDownloadClients(null));
      });
  };
};

export const setDownloadClients = (data) => ({
  type: types.cmDownloadClients,
  payload: data,
});

export const getClientLeads = (clientId) => {
  const url = `${API_URL}/api/v1/client/${clientId}/lead`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .get(url, {
        validateStatus: false,
      })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setGetClientLeads(outputData));
        } else {
          outputData['status'] = data.status;
          outputData['message'] = data.message;
          outputData['data'] = data.data;
          dispatch(setGetClientLeads(outputData));
        }
      })
        .catch((error) => {
          const status = error.response?.status;
          const message =
            status === 403 ? 'No tienes permisos para esta acción.' :
            status === 404 ? 'Recurso no encontrado.' :
            status === 500 ? 'Error del servidor. Intenta nuevamente.' :
            'Error de red. Verifica tu conexión.';
          dispatch(setGetClientLeads({ status: 'danger', error: true, message }));
        });
  };
};

export const setGetClientLeads = (data) => ({
  type: types.cmGetClientLeads,
  payload: data,
});

export const getClientOffers = (clientId) => {
  const url = `${API_URL}/api/v1/client/${clientId}/offer`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .get(url, {
        validateStatus: false,
      })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setGetClientOffers(outputData));
        } else {
          outputData['status'] = data.status;
          outputData['message'] = data.message;
          outputData['data'] = data.data;
          dispatch(setGetClientOffers(outputData));
        }
      })
        .catch((error) => {
          const status = error.response?.status;
          const message =
            status === 403 ? 'No tienes permisos para esta acción.' :
            status === 404 ? 'Recurso no encontrado.' :
            status === 500 ? 'Error del servidor. Intenta nuevamente.' :
            'Error de red. Verifica tu conexión.';
          dispatch(setGetClientOffers({ status: 'danger', error: true, message }));
        });
  };
};

export const setGetClientOffers = (data) => ({
  type: types.cmGetClientOffers,
  payload: data,
});

export const getClientQuotations = (clientId) => {
  const url = `${API_URL}/api/v1/client/${clientId}/quotation`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .get(url, {
        validateStatus: false,
      })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setGetClientQuotations(outputData));
        } else {
          outputData['status'] = data.status;
          outputData['message'] = data.message;
          outputData['data'] = data.data;
          dispatch(setGetClientQuotations(outputData));
        }
      })
        .catch((error) => {
          const status = error.response?.status;
          const message =
            status === 403 ? 'No tienes permisos para esta acción.' :
            status === 404 ? 'Recurso no encontrado.' :
            status === 500 ? 'Error del servidor. Intenta nuevamente.' :
            'Error de red. Verifica tu conexión.';
          dispatch(setGetClientQuotations({ status: 'danger', error: true, message }));
        });
  };
};

export const setGetClientQuotations = (data) => ({
  type: types.cmGetClientQuotations,
  payload: data,
});
